module.exports = __webpack_public_path__ + "static/media/visit_2.68894b73.jpg";